import { diffLines } from 'diff';

/**
 * Build a git-style unified diff that react-diff-view can parse.
 *
 * Extracted from VersionHistoryPanel so the Ground panel can render the same
 * diff without a second implementation — one place decides what a content
 * diff looks like.
 *
 * Returns '' when the two sides are effectively identical, so callers can
 * treat empty as "nothing changed" rather than rendering an empty diff frame.
 */
export function createGitDiff(oldStr: string, newStr: string): string {
  const changes = diffLines(oldStr, newStr);

  const hunkOldStart = 1;
  const hunkNewStart = 1;
  let hunkOldLines = 0;
  let hunkNewLines = 0;
  const hunkLines: string[] = [];

  for (const change of changes) {
    const changeLines = change.value.replace(/\n$/, '').split('\n');
    if (change.added) {
      for (const line of changeLines) {
        hunkLines.push('+' + line);
        hunkNewLines++;
      }
    } else if (change.removed) {
      for (const line of changeLines) {
        hunkLines.push('-' + line);
        hunkOldLines++;
      }
    } else {
      for (const line of changeLines) {
        hunkLines.push(' ' + line);
        hunkOldLines++;
        hunkNewLines++;
      }
    }
  }

  if (hunkLines.length === 0 || hunkLines.every((l) => l.startsWith(' '))) {
    return '';
  }

  return (
    [
      'diff --git a/content b/content',
      '--- a/content',
      '+++ b/content',
      `@@ -${hunkOldStart},${hunkOldLines} +${hunkNewStart},${hunkNewLines} @@`,
      ...hunkLines,
    ].join('\n') + '\n'
  );
}
